module.exports = __webpack_public_path__ + "img/model_38_zh.64a7a8cf.jpg";